module.exports = __webpack_public_path__ + "img/img20.145b3ceb.jpg";